import { TooltipApi } from './tooltip-api';
import { Subject } from 'rxjs'
import { distinctUntilChanged, debounceTime } from 'rxjs/operators';
import { TooltipLayer } from './tooltip-layer';

class TooltipWidget{
    constructor() {
        this._tooltipApi = null;
        this._el = null;
        this._linkEl = null;
        this._onClick = null;
        this._onMouseEnter = null;
        this._onMouseLeave = null;
        this.subscriptions = new Map();
        
    }
    init(){
        this.tooltipApi.init();
        this.tooltipLayer.init();
        this.tooltipApi.state.pipe(distinctUntilChanged(null, state=>{
            return state.isWidgetActive;
        })).subscribe( (state )=>{
            this.handleWidgetActiveChange(state.isWidgetActive);
        })

        this.linkEl.addEventListener('click',this.handleClick.bind(this))
        let onClick = this.onClick.subscribe(e=>{
            if(this.tooltipApi.state.isLayerEnabled){
                this.tooltipApi.showTooltip(true);
            }
        })
        
        this.linkEl.addEventListener('mouseenter',this.handleMouseEnter.bind(this));
        this.linkEl.addEventListener('mouseleave',this.handleMouseLeave.bind(this));
        this.onMouseEnter.subscribe(e=>{
            this.tooltipApi.setMouseOverWidget(true);
        })

        this.onMouseLeave.subscribe(e=>{
            this.tooltipApi.setMouseOverWidget(false);
        })
        let onMouseEnter = this.onMouseEnter.pipe(debounceTime(250)).subscribe(e=>{
            if(this.tooltipApi.state.isLayerEnabled){
                this.tooltipApi.showTooltip();
            }
        })
        let onMouseLeave = this.onMouseLeave.pipe(debounceTime(250)).subscribe(e=>{
            this.tooltipApi.hideTooltip();
        })
        this.subscriptions.set("onClick",onClick);
        this.subscriptions.set("onMouseEnter",onMouseEnter);
        this.subscriptions.set("onMouseLeave",onMouseLeave);
    }

    get TooltipLayer(){
        return TooltipLayer;
    }
    get tooltipApi(){
        if(this._tooltipApi == null){
            this._tooltipApi= new TooltipApi();
        }
        return this._tooltipApi;
    }
    get onClick(){
        if(this._onClick == null){
            this._onClick = new Subject();
        }

        return this._onClick;
    }
    get onMouseEnter(){
        if(this._onMouseEnter==null){
            this._onMouseEnter = new Subject();
        }
        return this._onMouseEnter;
    }
    get onMouseLeave(){
        if(this._onMouseLeave==null){
            this._onMouseLeave = new Subject();
        }
        return this._onMouseLeave;
    }
    get el() {
        if (this._el == null) {
            let el = document.createElement('div');
            el.classList.add('medscape-tooltip-widget');
            el.appendChild(this.linkEl);
            el.appendChild(this.tooltipLayer.el);
            this._el = el;
        }
        return this._el;
    }
    get linkEl() {
        if (this._linkEl == null) {
            let linkEl = document.createElement('a');
            this._linkEl = linkEl;
        }
        return this._linkEl;
    }
    get tooltipLayer(){
        if(this._tooltipLayer==null){
            this._tooltipLayer = new this.TooltipLayer(this.tooltipApi);
        }
        return this._tooltipLayer;
    }
    handleClick(e){
        this.onClick.next(e);
    }
    handleMouseEnter(e){
        this.onMouseEnter.next(e);
    }
    handleMouseLeave(e){
        this.onMouseLeave.next(e);
    }
    handleWidgetActiveChange(flag=this.tooltipApi.state.isWidgetActive){
        if(flag){
            this.linkEl.classList.add("active");
        }
        else{
            this.linkEl.classList.remove("active");
        }
    }

}

export { TooltipWidget }